__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "pp_portal_react";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@pperform/pp-services/AppEnvironmentService", "1.15.3", () => (() => (__webpack_require__(98421))), 1);
			register("@sentry/browser", "7.59.3", () => (() => (__webpack_require__(96575))), 1);
			register("@uirouter/react", "1.0.3", () => (() => (__webpack_require__(4201))), 1);
			register("moment", "2.29.4", () => (() => (__webpack_require__(78825))), 1);
			register("pp_shared_v2/src/config/endpoints.config", "0", () => (Promise.all([__webpack_require__.e(3019), __webpack_require__.e(2313)]).then(() => (() => (__webpack_require__(92313))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(40961))), 1);
			register("react-i18next", "15.7.3", () => (() => (__webpack_require__(67646))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(96540))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};